export default {
  name: "reportesCrm",
  component: () =>
    import(
      /* webpackChunkName: "reportesCrmLayout" */ "@/modules/reportesCrm/layouts/ReportesCrmLayout.vue"
    ),
  redirect: "/reportesCrm/general",
  children: [
    {
      path: "general",
      name: "reportes-general",
      redirect: "/reportesCrm/general/detalle",
      component: () =>
        import(
          /* webpackChunkName: "general" */ "@/modules/reportesCrm/pages/General.vue"
        ),
      children: [
        {
          path: "detalle",
          name: "reportes-detalle",
          component: () =>
            import(
              /* webpackChunkName: "detalle" */ "@/modules/reportesCrm/pages/Detalle.vue"
            ),
        },
        {
          path: "reporteInteracciones",
          name: "crm-reportes-reporteInteracciones",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteInteracciones" */ "@/modules/reportesCrm/pages/InteraccionesReport.vue"
            ),
        },
        {
          path: "reporteLeads",
          name: "crm-reportes-reporteLeads",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteLeads" */ "@/modules/reportesCrm/pages/LeadsReport.vue"
            ),
        },
        {
          path: "reportePersonas",
          name: "crm-reportes-reportePersonas",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reportePersonas" */ "@/modules/reportesCrm/pages/PersonasReport.vue"
            ),
        },
        {
          path: "reporteNegocios",
          name: "crm-reportes-reporteNegocios",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteNegocios" */ "@/modules/reportesCrm/pages/NegociosReport.vue"
            ),
        },
        {
          path: "reporteVentas",
          name: "crm-reportes-reporteVentas",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteVentas" */ "@/modules/reportesCrm/pages/VentasReport.vue"
            ),
        },
        {
          path: "reporteGeneral",
          name: "crm-reportes-reporteGeneral",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteGeneral" */ "@/modules/reportesCrm/pages/GeneralReport.vue"
            ),
        },
        {
          path: "reporteVentasAsesor",
          name: "crm-reportes-reporteVentasAsesor",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteVentasAsesor" */ "@/modules/reportesCrm/pages/VentaAsesorReport.vue"
            ),
        },
        {
          path: "reporteVentasInteraccion",
          name: "crm-reportes-reporteVentasInteraccion",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteVentasInteraccion" */ "@/modules/reportesCrm/pages/VentaInteraccionReport.vue"
            ),
        },
        {
          path: "reporteInteraccionGeneral",
          name: "crm-reportes-reporteInteraccionGeneral",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteInteraccionGeneral" */ "@/modules/reportesCrm/pages/InteraccionGeneralReport.vue"
            ),
        },
        {
          path: "reporteInteraccionAsesor",
          name: "crm-reportes-reporteInteraccionAsesor",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteInteraccionAsesor" */ "@/modules/reportesCrm/pages/InteraccionesAsesorReport.vue"
            ),
        },
        {
          path: "reporteRecompraGeneral",
          name: "crm-reportes-reporteRecompraGeneral",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteRecompraGeneral" */ "@/modules/reportesCrm/pages/RecompraGeneral.vue"
            ),
        },
        {
          path: "reporteVentaAsesor",
          name: "crm-reportes-reporteVentaAsesor",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteVentaAsesor" */ "@/modules/reportesCrm/pages/RecompraVentaAsesor.vue"
            ),
        },
        {
          path: "reporteRecompraVentaInteraccion",
          name: "crm-reportes-reporteRecompraVentaInteraccion",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteRecompraVentaInteraccion" */ "@/modules/reportesCrm/pages/RecompraVentaInteraccion.vue"
            ),
        },
        {
          path: "reporteRecompraInteraccionGeneral",
          name: "crm-reportes-reporteRecompraInteraccionGeneral",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteRecompraInteraccionGeneral" */ "@/modules/reportesCrm/pages/RecompraInteraccionGeneral.vue"
            ),
        },
        {
          path: "reporteRecompraInteraccionAsesor",
          name: "crm-reportes-reporteRecompraInteraccionAsesor",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-reporteRecompraInteraccionAsesor" */ "@/modules/reportesCrm/pages/RecompraInteraccionAsesor.vue"
            ),
        },
        {
          path: "funnelReport",
          name: "crm-reportes-funnelReport",
          component: () =>
            import(
              /* webpackChunkName: "crm-reportes-funnelReport" */ "@/modules/reportesCrm/pages/Funnel.vue"
            ),
        },
      ],
    },
  ],
};
